export const SHORT_LETS_CATEGORY_ID = 'short_term_lets';

const SHORT_LETS_SEARCH_PATTERN =
  /\b(?:short[-\s]*term[-\s]*lets?|short[-\s]*lets?|stl|airbnb|holiday[-\s]*lets?)\b/i;

const decodeSearchValue = (value) => {
  let decoded = String(value || '').replace(/\+/g, ' ');
  for (let i = 0; i < 2; i += 1) {
    try {
      const next = decodeURIComponent(decoded);
      if (next === decoded) break;
      decoded = next;
    } catch (_) {
      break;
    }
  }
  return decoded;
};

export const isShortLetsSearchQuery = (value) => {
  const values = Array.isArray(value) ? value : [value];
  return values.some((item) => SHORT_LETS_SEARCH_PATTERN.test(decodeSearchValue(item)));
};
